import { Table } from "reactstrap";
import { Uld, UldArray } from "./CreateTransferExport";
import { IAirport, IFFM } from "../../../../globals/interfaces";
import ActionIcon from "../../../custom/ActionIcon";
import Card from "../../../custom/Card";
import styled from "styled-components";
import { useState } from "react";
import ModalAwb from "./ModalAwb";
import { formatMawb } from "../../../../utils";

// add kilos

export default function RenderUlds({
    uldArray,
    setUldArray,
    uldKey,
    setUldKey,
    selectedUld,
    handleCreateUpdateUld,
    airportCodes,
    airportCodesMap,
    now
}: {
    uldArray: UldArray;
    setUldArray: React.Dispatch<React.SetStateAction<UldArray>>;
    uldKey: string;
    setUldKey: React.Dispatch<React.SetStateAction<string>>;
    selectedUld: Uld | null;
    handleCreateUpdateUld: (uldMapKey?: string) => void;
    airportCodes: Array<IAirport>;
    airportCodesMap: Record<string, string>;
    now: Date;
}) {

    const [modalAwb, setModalAwb] = useState(false);
    const [selectedAwb, setSelectedAwb] = useState<Partial<IFFM> | null>(null);

    const handleOpenAwbModal = (uldKey: string, awb?: Partial<IFFM>) => {
        setUldKey(uldKey);
        setSelectedAwb(awb || null);
        setModalAwb(true);
    };

    const Ulds = uldArray.map(item => item && (
        <Card className={'mb-2'}>
            <Flex>
                <h5>ULD: {item.uld}</h5>
                <ActionIcon
                    type={'update'}
                    onClick={() => handleCreateUpdateUld(item.key)}
                    size={16}
                />
            </Flex>
            <Table striped>
                <thead>
                    <tr>
                        <th>MAWB</th>
                        <th>Origin</th>
                        <th>Destination</th>
                        <th>Pieces</th>
                        <th>?</th>
                        <th>Commodity</th>
                        <th>SHC</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        item.data.map((ffm: IFFM, i) => ffm && (
                            <tr key={i} className={'text-hover'} onClick={() => handleOpenAwbModal(item.key, ffm)}>
                                <td>{formatMawb(ffm.s_mawb)}</td>
                                <td>{ffm.s_origin}</td>
                                <td>{ffm.s_destination}</td>
                                <td>{ffm.i_actual_piece_count}</td>
                                <td>{ffm.s_mawb}</td>
                                <td>{ffm.s_commodity}</td>
                                <td>{ffm.s_special_handling_code}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            <FlexEnd>
                <ActionIcon
                    type={'add'}
                    text={'MAWB'}
                    onClick={() => handleOpenAwbModal(item.key, null)}
                />
            </FlexEnd>
        </Card>
    ))

    return (
        <div>
            {Ulds}
            <ActionIcon
                type={'add'}
                text={'ULD'}
                onClick={() => handleCreateUpdateUld()}
            />
            <div>
                <h6>Instructions:</h6>
                <ul>
                    <li>Click on "+ ULD" to create a new ULD.</li>
                    <li>Click on "+ MAWB" to add AWBs to the ULD.</li>
                    <li>Click on "Submit Manifest" to create and complete the FFM.</li>
                </ul>
            </div>
            <ModalAwb
                modal={modalAwb}
                setModal={setModalAwb}
                setUldArray={setUldArray}
                selectedUld={selectedUld}
                selectedAwb={selectedAwb}
                airportCodes={airportCodes}
                airportCodesMap={airportCodesMap}
                now={now}
            />
        </div>
    );
}

const Flex = styled.div`
    display: flex;
    align-items: baseline;
    gap: 5px;
`;

const FlexEnd = styled.div`
    display: flex;
    justify-content: flex-end;
`;